import { Avatar, Dropdown, Space } from "antd";
import { Chat } from "enums/ChatType";
import "./BusinessMessage.scss";
import { getRelativeTimeString } from "helpers/messenger";
import { EllipsisOutlined } from "@ant-design/icons";
import { renderContent } from "./renderMessage";

export const BusinessMessage = ({
  content,
  sender,
  createdAt,
  _id,
  alignment = "right",
  canDelete = false,
  onDeleteClick = () => {},
}: Chat["messages"][number] & {
  alignment?: "left" | "right";
  onDeleteClick?: () => void;
  canDelete?: boolean;
}) => {
  const isRight = alignment === "right";

  return (
    <div key={_id} className={`business-message ${isRight ? "right" : "left"}`}>
      <div className="business-message__avatar">
        <Avatar src={sender.avatarUrl} />
      </div>
      <div className="business-message__content">
        {canDelete && (
          <div className="business-message__content-dropdown">
            <div className="elipsis-outlined">
              <Dropdown
                menu={{
                  items: [
                    {
                      label: "Delete message",
                      key: "0",
                      onClick: onDeleteClick,
                    },
                  ],
                }}
                trigger={["click"]}
              >
                <Space>
                  <div className="business-message__dropdown-trigger">
                    <EllipsisOutlined />
                  </div>
                </Space>
              </Dropdown>
            </div>
          </div>
        )}
        <div>{renderContent(content)}</div>
        <div
          style={{
            fontSize: 10,
            color: "#ffe9b5",
          }}
        >
          {getRelativeTimeString(new Date(createdAt))}
        </div>
      </div>
    </div>
  );
};
